<header class="py-3 mb-3 border-bottom shadow">
    <div class="container-fluid d-flex flex-row flex-nowrap justify-content-between" >
        <div class="d-flex flex-row flex-nowrap align-items-center">
            <a (click)="sidebarVisible = true;">
                <i class="bi bi-list menu"  (keypress.enter)="sidebarVisible = true;"></i>
            </a>
            <h5 class="ms-1 mb-0">Welcome {{user?.fullname}}</h5>
        </div>
        <div class="d-flex">
            <div class="me-2">
                <a href="https://docs.int.bayer.com/-/PH-RDEnablement/User%20Documentation/Time%20%20Tracking/Time_Tracking/" target="_blank" title="User Manual" class="userManual"><svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="30pt" height="25pt" viewBox="25 30 225 180" preserveAspectRatio="xMidYMid meet">  <g transform="translate(0.000000,219.000000) scale(0.050000,-0.050000)" fill="currentColor" stroke="none"> <path d="M2196 3529 c-360 -197 -404 -2196 -57 -2568 l57 -61 931 0 c1025 0 973 -6 973 119 0 119 -12 121 -811 121 l-731 0 -49 49 c-67 67 -66 168 3 233 l51 48 710 10 709 10 39 50 c72 93 79 175 79 971 0 1136 97 1037 -1026 1044 -699 3 -832 0 -878 -26z m1039 -355 c131 -120 -18 -335 -185 -265 -113 47 -144 162 -70 257 65 82 170 86 255 8z m-88 -433 c89 -34 94 -70 51 -390 -22 -163 -36 -308 -30 -323 20 -52 116 -32 172 35 61 74 140 56 140 -32 0 -165 -294 -289 -454 -192 -119 73 -135 133 -98 389 42 290 42 289 -23 304 -141 33 -192 133 -101 197 51 35 263 43 343 12z"></path> </g> </svg></a>
            </div>
            <div class="">
                <img
                    src="assets/bayer_logo.png"
                    alt="mdo"
                    class="logo"
                /> 
            </div>
        </div>
    </div>
</header>
<p-sidebar [(visible)]="sidebarVisible" styleClass="sidebar" appendTo="body" showCloseIcon="false">
    <ng-template pTemplate="headless">
        <div class="sidebarBody">
        <p-card styleClass="profile">
            <p-avatar icon="bi bi-person" styleClass="mr-2" size="large" shape="circle" />
            <p class="m-0">{{user?.email}}</p>
            <p class="m-0">{{user?.cwid}}</p>
            <p class="m-0">
              <ng-container *ngFor="let role of user?.roles">
                <p-tag [value]="role" styleClass="m-1 roleTag" />
              </ng-container>   
            </p>
        </p-card>
        <a class="no-decoration" (click)="navigate('/sst')" *ngIf="('/sst' != currentURL) && accessPermission.canAccess(accessPermission.taskList.access.sst)">
            <div class="navigate" >
                TT Single User Management
            </div>
        </a>
        <a class="no-decoration" (click)="navigate('/bulkupload')" *ngIf="('/bulkupload' != currentURL) && accessPermission.canAccess(accessPermission.taskList.access.bulkUpload)">
            <div class="navigate" >
                TT Bulk User Management
            </div>
        </a>
        <a class="no-decoration" (click)="navigate('/xpwd')" *ngIf="('/xpwd' != currentURL) && accessPermission.canAccess(accessPermission.taskList.access.xpwd)">
            <div class="navigate">
                XPWD
            </div>
        </a>
        <a class="no-decoration" (click)="navigate('/reports')" *ngIf="('/reports' != currentURL) && accessPermission.canAccess(accessPermission.taskList.access.mdr)">
            <div class="navigate" >
                TT Configuration Reports
            </div>
        </a>
         <a class="no-decoration" (click)="navigate('/closingdate')" *ngIf="('/closingdate' != currentURL) && accessPermission.canAccess(accessPermission.taskList.access.xpwd)">
            <div class="navigate" >
                Closing Dates and Rules
            </div>
        </a>
        
    </div>
    </ng-template>
</p-sidebar>
